import React from 'react';
import {Glyphicon} from 'react-bootstrap';

const ListItem =({text, id, remove})=>{
    return(
        <li>{text}<Glyphicon glyph='glyphicon glyphicon-trash' onClick={()=>remove(id)}/></li>
    )
};

export default ListItem;